import { useState } from 'react'

import { ApiError } from '../../lib/api'
import { useAuth } from '../../app/AuthContext'

export default function LoginPage() {
  const { login, register } = useAuth()
  const [mode, setMode] = useState<'login' | 'register'>('login')
  const [handle, setHandle] = useState('')
  const [password, setPassword] = useState('')
  const [email, setEmail] = useState('')
  const [orgName, setOrgName] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const submit = async (event: React.FormEvent) => {
    event.preventDefault()
    setError(null)
    setBusy(true)
    try {
      if (mode === 'login') await login(handle, password)
      else await register({
        email, username: handle, password, full_name: '', org_name: orgName,
      })
    } catch (e) {
      if (e instanceof ApiError) {
        setError(e.errors.length ? e.errors.map((x) => x.message).join('. ') : e.message)
      } else {
        setError('Could not reach the server. Is the API running?')
      }
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-head">
          <span className="brand-mark"
            style={{ width: 38, height: 38, fontSize: 17, margin: '0 auto' }}>₹</span>
          <h1>{mode === 'login' ? 'Invoice IQ' : 'Create a workspace'}</h1>
          <p>
            {mode === 'login'
              ? 'Upload an invoice. We read it. You approve it.'
              : 'You will be the owner of this workspace'}
          </p>
        </div>

        <form className="card" onSubmit={submit}>
          <div className="card-body">
            {error && <div className="form-error">{error}</div>}

            {mode === 'register' && (
              <>
                <div className="form-row">
                  <label htmlFor="org">Company name</label>
                  <input id="org" className="input" required value={orgName}
                    onChange={(e) => setOrgName(e.target.value)}
                    placeholder="Kanchan Auto Components" />
                </div>
                <div className="form-row">
                  <label htmlFor="email">Email</label>
                  <input id="email" className="input" type="email" required
                    value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
              </>
            )}

            <div className="form-row">
              <label htmlFor="handle">
                {mode === 'login' ? 'Username' : 'Choose a username'}
              </label>
              <input
                id="handle" className="input" required autoFocus
                autoComplete="username"
                value={handle} onChange={(e) => setHandle(e.target.value)}
                placeholder={mode === 'login' ? 'admin' : 'yourname'}
              />
            </div>

            <div className="form-row">
              <label htmlFor="password">Password</label>
              <input
                id="password" className="input" type="password" required
                autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
                value={password} onChange={(e) => setPassword(e.target.value)}
                minLength={mode === 'register' ? 8 : undefined}
              />
              {mode === 'register' && (
                <span className="muted" style={{ fontSize: 11.5 }}>
                  At least 8 characters
                </span>
              )}
            </div>

            <button className="btn btn-primary"
              style={{ width: '100%', marginTop: 4 }} disabled={busy}>
              {busy && <span className="spinner" />}
              {mode === 'login' ? 'Sign in' : 'Create workspace'}
            </button>

            <div style={{ textAlign: 'center', marginTop: 12, fontSize: 12.5 }}>
              <button type="button" className="btn btn-ghost btn-sm"
                onClick={() => { setMode(mode === 'login' ? 'register' : 'login'); setError(null) }}>
                {mode === 'login'
                  ? 'No workspace yet? Create one'
                  : 'Already have an account? Sign in'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
